import { brandclub_colors } from "@brandclub/common-ui";
import { decodeHTMLCharacters } from "@stackline/ui";
import React from "react";
import { getEntityImage } from "../../../../../../utils/StringUtils";
import { FlowSolidButton } from "../../components/FlowButtons";
import FlowContainer from "../../components/FlowContainer";
import FiveStarRating from "../components/FiveStarRating";
import {
  ReviewCoverContainer,
  ReviewCoverInfo,
  ReviewCoverLogo,
  ReviewCoverSubtitle,
  ReviewCoverTitle,
} from "../components/ReviewStyledComponents";
import { FlowActionButtonsGroup } from "../../components/FlowStyledComponents";

const Cover = ({
  reviewProduct,
  moveNext,
  starRating,
  setStarRating,
}: {
  reviewProduct: any;
  moveNext: () => void;
  starRating: number;
  setStarRating: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const cleanProductTitle = decodeHTMLCharacters(reviewProduct?.title || "");
  return (
    <FlowContainer style={{ background: brandclub_colors.white }}>
      <ReviewCoverContainer>
        <ReviewCoverInfo>
          <ReviewCoverLogo
            alt="product logo"
            src={getEntityImage(reviewProduct.stacklineSku, "product")}
          />

          <ReviewCoverSubtitle>{cleanProductTitle}</ReviewCoverSubtitle>
          <ReviewCoverTitle>What did you think?</ReviewCoverTitle>
          <FiveStarRating
            size={32}
            value={starRating}
            setValue={setStarRating}
          />
        </ReviewCoverInfo>
        <FlowActionButtonsGroup sx={{ justifyContent: "flex-end" }}>
          <FlowSolidButton disabled={!starRating} onClick={moveNext}>
            Next
          </FlowSolidButton>
        </FlowActionButtonsGroup>
      </ReviewCoverContainer>
    </FlowContainer>
  );
};

export default Cover;
